export default __webpack_public_path__ + "static/media/feedback_shap.822dfa27.png";